import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { usePageMeta } from "../../../hooks/usePageMeta";
import { Layout } from "../../layout/Layout";
import { TOSSection } from "./TOSSection";
import { tosSections, tosIntro, tosBoxContent, tosAmendParagraph } from "./tos.data";

export function TermsOfService() {
  const navigate = useNavigate();

  usePageMeta({
    title: "Terms of Use | 360PLUS",
    description: "Read the Terms of Use governing your access to and use of the 360PLUS app, website, and content.",
    canonical: "https://360plusapp.com/terms-of-service",
    noindex: true,
  });

  useEffect(() => {
    document.body.className = "legal-page";
    return () => { document.body.className = ""; };
  }, []);

  return (
    <section className="section section-masthead section-fullheight text-left bg-dark-1" data-arts-theme-text="light">
      <div className="section-masthead__inner section-fullheight__inner container-fluid">
        <div className="main-container">
        <Layout>
          <div className="legal-selector-container">
            <div
              className="legal-selector selected"
              onClick={() => navigate("/terms-of-service")}
              role="button"
              tabIndex={0}
            >
              Terms of Use
            </div>
            <div
              className="legal-selector"
              onClick={() => navigate("/privacy-policy")}
              role="button"
              tabIndex={0}
            >
              Privacy Policy
            </div>
          </div>

          <div className="legal-title-container">
            <div className="legal-title">Terms of Use</div>
            <div className="legal-date">Last updated: May 5, 2021</div>
          </div>

          <div
            className="legal-paragraph"
            dangerouslySetInnerHTML={{ __html: tosIntro }}
          />

          <div
            className="legal-box"
            dangerouslySetInnerHTML={{ __html: tosBoxContent }}
          />

          <div
            className="legal-paragraph"
            dangerouslySetInnerHTML={{ __html: tosAmendParagraph }}
          />

          <div className="legal-table-of-contents">
            <div className="table-of-contents-title">Table of Contents</div>
            <ol className="table-of-contents-items">
              {tosSections.map((s) => (
                <li key={s.number} className="table-of-contents-item">
                  <a>{s.title}</a>
                </li>
              ))}
            </ol>
          </div>

          {tosSections.map((section) => (
            <TOSSection key={section.number} section={section} />
          ))}
        </Layout>
        </div>
      </div>
    </section>
  );
}
